import { contentService } from '../../../services/content/content-service'

/**
 * Regenerate content method for the useContentGeneration composable
 * @param {Object} state - Content state object
 * @param {Function} generateFromTrend - Generate from trend function
 * @param {Function} generateManualContent - Generate manual content function
 * @returns {Function} Regenerate content function
 */
export const createRegenerateContent = (state, generateFromTrend, generateManualContent) => {
  /**
   * Regenerate content using the last generation parameters
   * @param {Object} assetStore - Asset store instance
   * @param {Function} t - Translation function
   * @returns {Promise<boolean>} Success status
   */
  return async (assetStore, t) => {
    // Create an object with generation functions
    const generateFuncs = {
      fromTrend: generateFromTrend,
      manual: generateManualContent,
    }
    
    // Use the content service
    return await contentService.regenerateContent(state, assetStore, generateFuncs, t)
  }
}
